import { renderDate } from '../utility/addressTabGridHelper';

export const DICT_SELECT_PROPS = {
  optionValue: 'Code',
  optionLabel: 'Description',
  showLabelOnly: false,
};

export const DEFAULT_VALUES = {
  OrigPrePlanDate: null,
  OccupancyType: '',
  ConstructionType: '',
  RoofType: '',
  BuildingCapacity: 0,
  NumberFloors: 0,
  NumberOfExits: 0,
  RequiredFlow: 0,
  AvailableFlow: 0,
  Notes: '',
  Firewalls: false,
  GasService: false,
  GasCutoffLocation: '',
  ElectricalService: false,
  ElectricalCutoffLocation: '',
  Sprinkler: false,
  SprinklerShutoffLocation: '',
  SprinklerFDConnectionLocation: '',
  Standpipe: false,
  StandpipeShutoffLocation: '',
  StandpipeFDConnectionLocation: '',
};

export const INSPECTION_GRID_COLUMNS = [
  {
    field: 'InspectionDate',
    headerName: 'Inspection Date',
    width: 180,
    valueFormatter: renderDate,
  },
  { field: 'PersonID', headerName: 'Person ID', width: 130 },
  { field: 'FullName', headerName: 'Inspector', width: 200 },
  { field: 'ShiftDesignation', headerName: 'Shift Designation', width: 160 },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 150 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 150 },
];
